import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';
import { verificationDoc } from '@app/_models/verificationDoc';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { statusRemark } from '@app/_models/statusRemark';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LogService } from '../../_shared/log.service';

@Component({
  selector: 'app-verifier-doc-list',
  templateUrl: './verifier-doc-list.component.html',
  styleUrls: ['./verifier-doc-list.component.css']
})
export class VerifierDocListComponent implements OnInit {
  request: verificationDoc[];
  requestNew: [];
  msgOnButtonClick: string;
  msgOnChildCompInit: String;
  dtTrigger: Subject<any> = new Subject<any>();
  fromDate: string;
  toDate: string;
  reasonVal: string;
  statusRemark = new statusRemark();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  upload_doc_path: any = "/University/assets/images/No-results-found.jpg";
  originalDocUploadFilePath: any = "/University/assets/images/No-results-found.jpg";
  getId: number;
  //imageToShow: any;
  title = 'docVerification';
  dtOptions: DataTables.Settings = {};
  buttonStatus: string;
  isVrPdf: boolean = false;
  isVrImage: boolean = false;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  cgpiVal: string;
  prevCgpi;
  fileURL;
  fileURL1;
  src;
  CGPIForm: FormGroup;
  src1;
  isImageR = false;
  isImageL = false;
  returnUrl
  RemarkForm: FormGroup;
  submitted = false;
  submitted1 = false;
  submitted3 = false;
  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  currentIndex
  imageObject: Array<object> = [];
  remark: string;
  OnlyRemarkForm: FormGroup;
  onlyRemarkVal: string;
  noImage1 = false;
  noImage2 = false;
  imgname = "uploadImg1"
  imgname2 = "uploadImg2"

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebuttonRemark') closebuttonRemark;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;


  constructor(
    private verifyDocService: VerifyDocumentService,
    private documentVerificationListService: DocumentVerificationListService,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private eventService: LogService) { }

  ngOnInit(): void {
    this.OnlyRemarkForm = this.formBuilder.group({

      onlyRemarkVal: ['', Validators.required]
    });
    this.RemarkForm = this.formBuilder.group({

      cgpiVal: ['', Validators.required],
      reasonVal: ['', Validators.required]
    });
    this.CGPIForm = this.formBuilder.group({

      cgpiVal: ['', Validators.required]
    });

  }
  

  showLightbox(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;

    this.imageObject = [
      {
        image: this.upload_doc_path,
        alt: 'alt of image', // Optional
        title: 'To be verified' // Optional: Show image with description text 
      },
      {
        image: this.originalDocUploadFilePath, // Support base64 image
        title: 'System document', //Optional: You can use this key if want to show image with title
        alt: 'Image alt' //Optional: You can use this key if want to show image with alt
      }
    ];
  }

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }
  showRemark(strReason) {
    this.remark = strReason;
  }


  onInitDate(p) {
    var i = 0;
    this.msgOnChildCompInit = p;
    this.fromDate = p.fromDatee;
    this.toDate = p.toDatee;
    // alert(p.fromDatee)
    var userId = localStorage.getItem('user_id');
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    // this.verifyDocService.getVerificationDocsSuperVerifier( this.fromDate, this.toDate)
    this.verifyDocService.getVerificationDocsSuperVerifier(this.fromDate, this.toDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          this.requestNew = data.respData;
          this.request = this.requestNew; const v = this.request.filter(m => m.doc_status == 'Rejected' || m.doc_status == 'Approved' || m.doc_status == 'SV_Approved' || m.doc_status == 'SV_Rejected' || m.doc_status == 'Requested' || m.doc_status == 'Unable To Verify' || m.doc_status == 'Offline' || m.doc_status == 'SV_Unable To Verify' || m.doc_status == 'SV_Offline')
          // this.prevCgpi = 
          this.request = v;
          console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })
  }

  getData(p) {
    this.msgOnButtonClick = p;
    //alert('this.msgOnButtonClick  '+this.msgOnButtonClick);
    this.verifyDocService.getVerificationDocsSuperVerifier(p.fromDatee, p.toDatee)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          this.requestNew = data.respData;
          console.log(this.request)          
          if (p.status == 'Closed') {
            const v = this.request.filter(m => m.doc_status == 'UN_Approved' || m.doc_status == 'UN_Approved_Pass' || m.doc_status == 'UN_Approved_Fail' || m.doc_status == 'UN_Rejected' || m.doc_status == 'Uni_Auto_Approved' || m.doc_status == 'Uni_Auto_Rejected' || m.doc_status == 'SVD_Rejected' || m.doc_status == 'SVD_Approved' || m.doc_status == 'SVD_Approved_Pass' || m.doc_status == 'SVD_Approved_Fail')
            this.request = v;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next();
            });
          }
          else if (p.status == 'Open') {
            const v = this.request.filter(m => m.doc_status == 'Rejected' || m.doc_status == 'Approved' || m.doc_status == 'SV_Approved' || m.doc_status == 'SV_Rejected' || m.doc_status == 'Requested' || m.doc_status == 'Unable To Verify' || m.doc_status == 'Offline' || m.doc_status == 'SV_Unable To Verify' || m.doc_status == 'SV_Offline')
            this.request = v;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next();
            });
          }
          else {
            // this.request = this.requestNew;
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next();
            });
          }
        },
        error => {
          console.log(error)
        })
    
    
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  get f() { return this.RemarkForm.controls; }
  get g() { return this.CGPIForm.controls; }
  get h() { return this.OnlyRemarkForm.controls; }

  openPdf() {
    window.open(this.fileURL);
  }

  openPdf1() {
    window.open(this.fileURL1);
  }

  openModal(id, status, prevCgp) {
    // this.display = "block";  
    this.prevCgpi = prevCgp;
    console.log("prevCGPI--->", prevCgp);
    this.getId = id;
    this.isVrImage = false;
    this.isVrPdf = false;
    this.buttonStatus = status;
    this.upload_doc_path = '';
    this.originalDocUploadFilePath = '';
    this.isImageR = false;
    this.isImageL = false;
    this.SpinnerService.show();
    this.documentVerificationListService.getverifydocument(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].upload_doc_path).pipe(first())
            .subscribe(
              add => {
                console.log("addadd---", add)
                let reader = new FileReader();
                if (add.type == "application/pdf") {
                  this.isVrPdf = true;
                  this.isVrImage = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    var base64Array = this.upload_doc_path.substring(28);
                    console.log("=====base64Array===========", base64Array);
                    this.src = this._base64ToArrayBuffer(base64Array);
                    let file = new Blob([add], { type: 'application/pdf' });
                    this.fileURL = URL.createObjectURL(file);
                  }, false);
                } else {
                  this.isVrImage = true;
                  this.isVrPdf = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    this.noImage1 = false;
                  }, false);
                }
                if (add) {
                  reader.readAsDataURL(add);
                }
                this.isImageL = true;
                if (this.isVrPdf == true) {
                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }
                console.log("=======img===========L======", this.isImageR, this.isImageL);
                if (this.isImageL == true && this.isImageR == true) {
                  this.SpinnerService.hide();
                  this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                }
              }, error => {
                this.isImageL = true;
                if (this.isImageL == true && this.isImageR == true) {
                  this.SpinnerService.hide();
                  this.modalService.open(this.showModalBoxImage, {windowClass: 'my-class', centered: true });
                }

                this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
                this.noImage1 = true;
                console.log(error)
              }
            )
          if (data.respData[0].originalDocUploadFilePath != undefined) {
            this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].originalDocUploadFilePath).pipe(first())
              .subscribe(
                data2 => {
                  console.log("data2---", data2, data2.type)
                  let reader = new FileReader();
                  if (data2.type == "application/pdf") {
                    this.isUPdf = true;
                    this.isUImage = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      var base64Array = this.originalDocUploadFilePath.substring(28);
                      console.log("=====base64Array===========", base64Array);
                      this.src1 = this._base64ToArrayBuffer(base64Array);
                      let file = new Blob([data2], { type: 'application/pdf' });
                      this.fileURL1 = URL.createObjectURL(file);
                    }, false);
                  } else {
                    this.isUImage = true;
                    this.isUPdf = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      console.log(reader.result);
                      this.noImage2 = false;
                    }, false);
                  }
                  console.log(this.isUImage, this.isUPdf)
                  if (data2) {
                    reader.readAsDataURL(data2);
                  }
                  this.isImageR = true;
                  if (this.isUPdf == true) {
                    var al = window.open('', 'OPEN');
                    window.setTimeout(function () { al.close() }, 100);
                  }
                  console.log("=======img===========R======", this.isImageR, this.isImageL);
                  if (this.isImageL == true && this.isImageR == true) {
                    this.SpinnerService.hide();
                    this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                  }
                }),
              console.log(this.request)
          }
          else {
            this.isUPdf = false;
            this.isUImage = true;
            this.isImageR = true;
            this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg";
            this.noImage2 = true;
          }
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
          }
        },
        error => {
          this.isUPdf = false;
          this.isUImage = true;
          this.isImageR = true;
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
          }
          this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
          this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; // test server path
          this.noImage2 = true;
          console.log(error)
        }
      )

  }

  openRemarkModal(nm) {
    this.f.cgpiVal.setValue(this.prevCgpi);
    
    // this.RemarkForm.controls..cgpiVal='77'
    this.reasonVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    console.log(nm);
  }

  openCgpiModal(nm){
    this.g.cgpiVal.setValue(this.prevCgpi);
    this.cgpiVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
  }

  openOnlyRemarkModal(nm){
    this.onlyRemarkVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    // this.h.onlyRemarkVal
  }

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  changeOnlyRemarkStatus(e){

    this.submitted3 = true;

    this.documentVerificationListService.setStatusSV(this.statusRemark)
    .pipe(first())
    .subscribe(
      data => {
        console.log("response---", data)
        this.SpinnerService.hide();
        this.verifyDocService.getVerificationDocsSuperVerifier(this.fromDate, this.toDate)
          .pipe(first())
          .subscribe(
            data => {
              this.request = data.respData;
              this.requestNew = data.respData;
            },
            error => {
              //console.log(error)
            })
        this.closebuttonRemark.nativeElement.click();
        this.modalService.open(this.showModalBoxTemplate);
      },
      error => {
        console.log(error)
      }
    ),
    this.SpinnerService.show();

  }

  changeRemarkStatus(e) {
    this.submitted = true;
    this.statusRemark.remark = this.reasonVal;
    this.statusRemark.cgpi = this.cgpiVal;
    if (this.RemarkForm.invalid) {
      return;
    }
    let verifiedby = localStorage.getItem('user_id');
    this.statusRemark.verifiedby = verifiedby;
    this.statusRemark.remark = this.reasonVal;
    //alert(this.reasonVal)
    this.documentVerificationListService.setStatusSV(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          this.verifyDocService.getVerificationDocsSuperVerifier(this.fromDate, this.toDate)
            .pipe(first())
            .subscribe(
              data => {
                this.request = data.respData;
                this.requestNew = data.respData;
              },
              error => {
                //console.log(error)
              })
          this.closebuttonRemark.nativeElement.click();
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();
  }
  changeStatus(e) {
    //  alert(e.target.name);
    this.submitted1 = true;
    var id = this.getId;
    var status = e.target.name;
    // this.statusRemark.remark = this.reasonVal;
    let verifiedby = localStorage.getItem('user_id');
    this.statusRemark.verifiedby = verifiedby;
    this.statusRemark.id = this.getId;
    if(e.target.name=="Requested"){
     this.statusRemark.status = e.target.name;
     console.log("Status......",e.target.name)
  }
  else{  
    //this.statusRemark.cgpi = this.prevCgpi;
    this.statusRemark.cgpi=this.cgpiVal;
    //var status = "SV_Approved";
    console.log(id)

    if (this.CGPIForm.invalid) {
      return;
    }
  }
    this.documentVerificationListService.setStatusSV(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          this.verifyDocService.getVerificationDocsSuperVerifier(this.fromDate, this.toDate)
            .pipe(first())
            .subscribe(
              data => {
                // console.log("response---", data)
                this.request = data.respData;
                this.requestNew = data.respData;
              },
              error => {
                //console.log(error)
              })
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();
  }

  refresh(): void {
    location.reload();
    // this.closebuttonRemark.nativeElement.click();
    // this.closebutton.nativeElement.click();
    // this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.returnUrl = "superVerifier";
    // this.router.navigate([this.returnUrl]);
  }
}
